(function () {
    VjsAdmin.Controller = {};
    VjsAdmin.Controller.extend = function (extendProperties) {
        return VjsAdmin.extend(controller, extendProperties);
    };

    const controller = function () {};
    controller.prototype = {
        construct() {
            this.setEvents();
        },
        setEvents() {
            const { events } = this;
            Object.keys(events).forEach((key) => {
                const s = key.split(' ');

                if (s[0] === 'scroll') {
                    $(window).off(s[0]);
                    $(window).on(s[0], { items: events[key], that: this }, (e) => {
                        // Passing Context
                        const { that } = e.data;
                        that[e.data.items](e);
                    });
                } else {
                    // Remove the same event before adding another
                    $('body').off(s[0], s[1]);
                    $('body').on(s[0], s[1], { items: events[key], that: this }, (e) => {
                        // Passing Context
                        const { that } = e.data;
                        that[e.data.items](e);
                    });
                }
            });
        },
    };
}());
